import type { SwatchRouter } from "replo-publisher/src/trpc/routers/swatch";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: swatchRouter,
  client: swatchClient,
  utils: swatchUtils,
  options: swatchOptions,
} = createTrpcRouterConfig<SwatchRouter>({
  path: "swatch",
  queryClient: getNamespacedQueryClient("swatch"),
});

export { swatchClient, swatchRouter, swatchUtils, swatchOptions };
